import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { Logo } from "@/components/Logo";

const LINKS = [
  { href: "#services", label: "Services" },
  { href: "#fonctionnement", label: "Comment ça marche" },
  { href: "#zone", label: "Zone de livraison" },
  { href: "#tarifs", label: "Tarifs" },
  { href: "#faq", label: "Questions" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-cream/90 shadow-[0_1px_0_0_#D5E9F0] backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <a href="#haut" aria-label="Angélivraisons — retour en haut">
          <Logo />
        </a>
        <nav className="hidden items-center gap-8 lg:flex" aria-label="Navigation principale">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-ink/70 transition-colors duration-200 hover:text-forest"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="tel:+33673318236"
            data-testid="hero-phone-button"
            className="hidden min-h-[48px] items-center gap-2 rounded-full border border-forest/25 px-4 text-sm font-semibold text-forest transition-colors duration-200 hover:bg-forest hover:text-cream sm:flex"
          >
            <Phone className="h-4 w-4" />
            06 73 31 82 36
          </a>
          <a
            href="#reserver"
            data-testid="nav-booking-cta"
            className="flex min-h-[48px] items-center rounded-full bg-terra px-5 text-sm font-semibold text-white shadow-[0_8px_20px_-8px_#EE6FA3] transition-all duration-200 hover:-translate-y-0.5 hover:bg-terra-dark"
          >
            Réserver une livraison
          </a>
        </div>
      </div>
    </header>
  );
}
